<a [href]="'tel:' + phoneNumber()">
	<p-button
		[label]="phoneNumber() || '' | phoneFormat"
		[dt]="designToken"
		icon="pi pi-phone"
		[fluid]="fluid"
		[size]="size"
		class="whitespace-nowrap" />
</a>
